//! CUSTOM HOOK FOR FIREBASE

import { useState, useEffect } from "react";
import {
  projectStorage,
  projectFirestore,
  timestamp,
} from "../firebase/config";

const useStorage = (file) => {
  const [progress, setProgress] = useState(0); // progress uploadu
  const [error, setError] = useState(null); //error
  const [url, setUrl] = useState(null); //image url after image fully uploaded

  useEffect(() => {
    //referecnes
    const storageRef = projectStorage.ref(file.name); // zapisz nazwe pliku do projectStorage //firebase storage
    const collectionRef = projectFirestore.collection("images"); // utwórz kolekcje 'images' z url przeslanych zdjec w FireStore Database

    //odapl funkcje za KAZDYM razem gdy state sie zmieni ( upload, postęp  przeyłania etc)
    storageRef.put(file).on(
      "state_changed",
      (snap) => {
        // zapisz % uploadu w zmiennej aktualnie przesłane bajty / całkowita wielkośc * 100
        let uploadPercentage = (snap.bytesTransferred / snap.totalBytes) * 100;
        setProgress(uploadPercentage); // aktualizuj progress
      },
      (err) => {
        setError(err);
      },
      async () => {
        const url = await storageRef.getDownloadURL(); // gdy zdjęcie sie wysle poprawnie zapisz url zdjęcia w state url
        const createdAt = timestamp(); // z config.js
        collectionRef.add({ url: url, createdAt: createdAt }); // zapisz url i czas uploadu w Firestore Database
        setUrl(url);
      }
    );
  }, [file]); // funkcja w useEffect uruchomi sie za kazdym razem gdy file ulegni zmienie

  return { progress, url, error }; // exportuj stany
};

export default useStorage;
